import { defineMessages } from '../define';

/** Song page: the strip of open songs and lists ("Opin lög"), the sheet menu and the list drawer. */
export const tabs = defineMessages(
  {
    'tabs.label': 'Opin lög',
    'tabs.move': 'Færa opnu lögin',
    'tabs.move_hint': 'Dragðu þau efst eða neðst á nóturnar. Örvalyklar færa þau líka.',
    'tabs.fold': 'Fela hin opnu lögin',
    'tabs.unfold': { one: 'Sýna öll opin lög ({count} í viðbót)', other: 'Sýna öll opin lög ({count} í viðbót)' },
    'tabs.close': 'Loka „{title}“',
    'tabs.open_more': 'Opna lag eða lista',
    'tabs.choose_sheet': 'Velja nótur',
    'tabs.song_aria': '{title} – nótur: {sheet}',
    'tabs.collection_aria': '{name} – lag {position} af {total}',
    'tabs.list_position': '{position}/{total}',
    'tabs.show_list': 'Sýna lögin á listanum',
    'tabs.list_title': 'Lög á „{name}“',
    'tabs.no_songs': 'Engin lög á listanum sem þú hefur aðgang að',
  },
  {
    'tabs.label': 'Open songs',
    'tabs.move': 'Move the open songs',
    'tabs.move_hint': 'Drag them to the top or bottom of the sheet. Arrow keys move them too.',
    'tabs.fold': 'Hide the other open songs',
    'tabs.unfold': { one: 'Show all open songs ({count} more)', other: 'Show all open songs ({count} more)' },
    'tabs.close': 'Close “{title}”',
    'tabs.open_more': 'Open a song or list',
    'tabs.choose_sheet': 'Choose sheet music',
    'tabs.song_aria': '{title} – sheet: {sheet}',
    'tabs.collection_aria': '{name} – song {position} of {total}',
    'tabs.list_position': '{position}/{total}',
    'tabs.show_list': 'Show the songs in the list',
    'tabs.list_title': 'Songs in “{name}”',
    'tabs.no_songs': 'No songs in this list that you can see',
  },
);
